import {createContext} from "react";
import {Dictionary} from "../types/hygiena-types";

export const DictionaryContext = createContext<Dictionary>({});